<template>
  <router-view />
</template>

<script>
export default {
  name: 'withdrawLayout'
};
</script>

<style></style>
